import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';

export const SignupPage = () => {
  const navigate = useNavigate();
  const [selectedRole, setSelectedRole] = useState('4-year-coach');

  const roles = [
    {
      id: '4-year-coach',
      label: '4-Year Coach'
    },
    {
      id: 'scout',
      label: 'Scout',
      comingSoon: true
    },
    {
      id: 'player',
      label: 'Player'
    },
    {
      id: 'juco-coach',
      label: 'JUCO Coach',
      comingSoon: true
    },
    {
      id: 'media',
      label: 'Media',
      comingSoon: true
    }
  ];

  const handleContinue = () => {
    if (selectedRole === '4-year-coach') {
      navigate('/auth/register-coach');
    } else if (selectedRole === 'scout') {
      navigate('/auth/register-scout');
    } else if (selectedRole === 'player') {
      navigate('/auth/login-player');
    } else if (selectedRole === 'juco-coach' || selectedRole === 'media') {
      navigate('/auth/coming-soon');
    }
  };

  return (
    <main className="min-h-screen bg-jp-page text-jp-ink text-left overflow-x-hidden">
      {/* Navy strip behind the see-through navbar so its white logo and links stay readable */}
      <div className="bg-jp-band h-16 sm:h-20" aria-hidden="true" />

      <section className="px-4 sm:px-6 lg:px-8 pt-14 sm:pt-20 pb-16 sm:pb-20">
        <div className="max-w-md mx-auto text-center mb-8">
          <p className="text-jp-accent dark:text-jp-gold text-sm font-bold uppercase tracking-widest mb-3">
            Get Started
          </p>
          <h1 className="text-5xl sm:text-6xl font-anton leading-[1.1] tracking-tight text-jp-ink">
            WHO ARE YOU?
          </h1>
          <p className="mt-4 text-jp-muted text-sm sm:text-base">
            Pick the account type that fits you.
          </p>
        </div>

        <div className="max-w-6xl mx-auto bg-jp-card rounded-2xl border border-jp-outline/70 shadow-sm p-5 sm:p-8">
          {/* Role tiles */}
          <div className="grid grid-cols-2 lg:grid-cols-5 gap-4" role="radiogroup" aria-label="Account type">
            {roles.map((role) => {
              const isSelected = selectedRole === role.id;
              return (
                <button
                  key={role.id}
                  type="button"
                  role="radio"
                  aria-checked={isSelected}
                  disabled={role.comingSoon}
                  onClick={() => setSelectedRole(role.id)}
                  className={`relative rounded-xl px-5 pt-10 pb-8 min-h-[170px] sm:min-h-[200px] flex flex-col items-center justify-center text-center border transition-colors focus:outline-none focus-visible:ring-2 focus-visible:ring-jp-accent ${
                    role.comingSoon
                      ? 'bg-jp-section border-jp-outline/50 opacity-60 cursor-not-allowed'
                      : isSelected
                        ? 'bg-jp-accent/10 border-jp-accent ring-1 ring-jp-accent'
                        : 'bg-jp-section border-jp-outline/50 hover:border-jp-accent/60'
                  }`}
                >
                  {/* Selection dot - only for roles that can be picked */}
                  {!role.comingSoon && (
                    <span
                      className={`absolute top-4 right-4 w-6 h-6 rounded-full border-2 flex items-center justify-center transition-colors ${
                        isSelected ? 'border-jp-accent' : 'border-jp-line'
                      }`}
                    >
                      {isSelected && <span className="w-3 h-3 rounded-full bg-jp-accent" />}
                    </span>
                  )}

                  <span className={`text-lg sm:text-2xl font-bold ${isSelected ? 'text-jp-accent' : 'text-jp-ink'}`}>
                    {role.label}
                  </span>

                  {role.comingSoon && (
                    <span className="mt-2 text-xs font-bold uppercase tracking-widest text-jp-muted">
                      Coming Soon
                    </span>
                  )}
                </button>
              );
            })}
          </div>

          <div className="max-w-md mx-auto pt-8">
            <button
              type="button"
              onClick={handleContinue}
              className="w-full py-4 text-base font-bold uppercase tracking-wider bg-gradient-to-r from-cyan-400 via-cyan-500 to-blue-600 text-slate-900 rounded-xl hover:brightness-110 transition-all shadow-lg shadow-cyan-500/20 focus:outline-none focus-visible:ring-2 focus-visible:ring-jp-accent focus-visible:ring-offset-2 focus-visible:ring-offset-jp-card active:scale-[0.98]"
            >
              Create My Account
            </button>
          </div>

          <p className="px-2 pt-5 pb-1 text-center text-sm sm:text-base text-jp-muted">
            Already have an account?{' '}
            <Link to="/auth/login" className="font-semibold text-jp-accent hover:underline">
              Sign in
            </Link>
          </p>
        </div>
      </section>
    </main>
  );
};

export default SignupPage;
